// import { AutorenewOutlined } from "@mui/icons-material";
import { Box, Button, DialogTitle, Divider, Snackbar, Typography } from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
// import Tab from "@mui/material/Tab";
// import Tabs from "@mui/material/Tabs";
import { format } from "date-fns";
import addDays from "date-fns/addDays";
import { useConfirm } from "material-ui-confirm";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import LoadingButton from "../../../../../design/wilya-loading-button";
import { useDateFnsLocale } from "../../../../../utils/date-locale";
import {
  closeGenerateFullTimeShiftSchedulerModal,
  generateSchedule,
  resetGenerateSchedule,
  resetSaveOverrides,
  saveOverrides
} from "../../../store/full-time-shifts-slice";
import { FullTimeShiftRootState } from "../../../store/full-time-shifts-type";
import GenerateScheduleLoader from "./generate-schedule-loader";
import {
  TotalWorkerMovement
} from "./total-worker-movement";

type ReviewScheduleDialogProps = {
  dateRange: {
    startDate: Date;
    endDate: Date;
  },
  locationId: number;
}
export const ReviewScheduleDialog = ({
  dateRange,
  locationId,
}:ReviewScheduleDialogProps) => {
  const { t } = useTranslation();
  const dateLocale = useDateFnsLocale();
  const dispatch = useDispatch();
  const confirm = useConfirm();

  const [activeTab, setActiveTab] = useState(0);

  const workerReassignments = useSelector(
    (state: FullTimeShiftRootState) => state.fullTimeShifts.workerReassignments
  );

  const generateScheduleStatus = useSelector(
    (state: FullTimeShiftRootState) => state.fullTimeShifts.generateSchedule.status
  );

  const generateScheduleErrorMessage = useSelector(
    (state: FullTimeShiftRootState) => state.fullTimeShifts.generateSchedule.errorMessage
  );

  const saveOverridesStatus = useSelector(
    (state: FullTimeShiftRootState) => state.fullTimeShifts.saveOverrides.status
  );

  const saveOverridesErrorMessage = useSelector(
    (state: FullTimeShiftRootState) => state.fullTimeShifts.saveOverrides.errorMessage
  );

  useEffect(() => {
    if (locationId !== null) {
      dispatch(generateSchedule({
        locationId: locationId,
        fromDate: format(dateRange?.startDate, "yyyy-MM-dd"),
        toDate: format(addDays(dateRange?.startDate, 6), "yyyy-MM-dd"),
      }));
    }
  }, [dateRange?.startDate, dispatch, locationId]);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  const isGeneratingSchedule = generateScheduleStatus !== "fulfilled";
  const totalWorkerMovementCount = workerReassignments?.length ?? 0;

  const gap = 0;
  const totalGapBackgroundColor = gap === 0 ?
    "#E8F5E9" : gap > 0 ?
    "#FFE5B9" : "#F9DEDC";
  // Remove the negative sign from gap to use it as a positive value
  const totalGapValue = Math.abs(gap);
  const startDate = useMemo(() => {
    return dateRange?.startDate ? dateRange.startDate : new Date();
  }, [dateRange?.startDate]);
  const endDate = useMemo(() => {
    return addDays(new Date(startDate), 6);
  }, [startDate]);
  const isGenerateFullTimeShiftSchedulerModalOpen = useSelector(
    (state: FullTimeShiftRootState) => state.fullTimeShifts.isGenerateFullTimeShiftSchedulerModalOpen
  );
  return (
      <Dialog
        open={isGenerateFullTimeShiftSchedulerModalOpen}
        maxWidth="xl"
        fullWidth
        onClose={() => {
          // Dispatch action to close the dialog
          dispatch(resetSaveOverrides());
          dispatch(resetGenerateSchedule());
          dispatch(closeGenerateFullTimeShiftSchedulerModal());
        }}
        slotProps={{
          paper: {
            sx: {
              height: "calc(100vh - 64px)",
              maxHeight: "calc(100vh - 64px)",
              margin: "32px 0",
              display: "flex",
              flexDirection: "column"
            }
          }
        }}
      >
        <Box
          sx={{
            display: "flex",
            width: "100%",
            flexDirection: "column",
            overflowX: "auto",
            minWidth: isGeneratingSchedule ? "0px" : "1536px",
            height: "100%",
          }}
        >
          <DialogTitle
            sx={{
              padding: "45px 0px 24px 0px",
            }}
          >
            <Box sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "center",
              gap: "24px",
            }}>
              <Typography
                sx={{
                  fontFamily: "Roboto",
                  fontSize: "20px",
                  fontWeight: 400,
                  lineHeight: "32px",
                  color: "rgba(0,0,0,0.87)",
                  paddingLeft: "45px",
                  paddingRight: "45px",
                  marginLeft: "2px",
                }}
              >
                {isGeneratingSchedule
                  ? t("full-time-shifts_generating-schedule-week", {
                    start: format(startDate, "M/d (EEE)", { locale: dateLocale }),
                    end: format(endDate, "M/d (EEE)", { locale: dateLocale }),
                  })
                  : t("full-time-shifts_review-schedule-week", {
                    start: format(startDate, "M/d (EEE)", { locale: dateLocale }),
                    end: format(endDate, "M/d (EEE)", { locale: dateLocale }),
                  })}
              </Typography>
              {/*{!isGeneratingSchedule && (*/}
              {/*  <Box sx={{*/}
              {/*    display: "flex",*/}
              {/*    flexDirection: "column",*/}
              {/*    alignItems: "flex-start",*/}
              {/*    justifyContent: "center",*/}
              {/*    width: "100%",*/}
              {/*    gap: "0px",*/}
              {/*  }}>*/}
              {/*    <Tabs value={activeTab} onChange={handleTabChange}>*/}
              {/*      <Tab*/}
              {/*        label="Total Worker Movement"*/}
              {/*        sx={{*/}
              {/*          textTransform: "uppercase",*/}
              {/*          fontFamily: "Roboto",*/}
              {/*          fontSize: "14px",*/}
              {/*          fontWeight: 500,*/}
              {/*          lineHeight: "24px",*/}
              {/*          letterSpacing: "0.4px",*/}
              {/*          padding: "9px 16px",*/}
              {/*          color: activeTab === 0 ? "#2F4D8B" : "rgba(0, 0, 0, 0.60)",*/}
              {/*          minHeight: "auto",*/}
              {/*          paddingLeft: "45px",*/}
              {/*        }}*/}
              {/*        iconPosition="end"*/}
              {/*        icon={<Box*/}
              {/*          sx={{*/}
              {/*            backgroundColor: "#E8F5E9",*/}
              {/*            borderRadius: "12px",*/}
              {/*            width: "24px",*/}
              {/*            height: "24px",*/}
              {/*            display: "flex",*/}
              {/*            justifyContent: "center",*/}
              {/*            alignItems: "center",*/}
              {/*          }}*/}
              {/*        >*/}
              {/*          <Typography*/}
              {/*            sx={{*/}
              {/*              fontSize: "12px",*/}
              {/*              fontFamily: "Roboto",*/}
              {/*              color: "rgba(0,0,0,0.87)",*/}
              {/*            }}*/}
              {/*          >*/}
              {/*            {totalWorkerMovementCount}*/}
              {/*          </Typography>*/}
              {/*        </Box>}*/}
              {/*      />*/}
              {/*      <Tab*/}
              {/*        label="Total Gaps Remaining"*/}
              {/*        sx={{*/}
              {/*          textTransform: "uppercase",*/}
              {/*          fontFamily: "Roboto",*/}
              {/*          fontSize: "14px",*/}
              {/*          fontWeight: 500,*/}
              {/*          lineHeight: "24px",*/}
              {/*          letterSpacing: "0.4px",*/}
              {/*          padding: "9px 16px",*/}
              {/*          color: activeTab === 1 ? "#2F4D8B" : "rgba(0, 0, 0, 0.60)",*/}
              {/*          minHeight: "auto",*/}
              {/*        }}*/}
              {/*        iconPosition="end"*/}
              {/*        icon={<Box*/}
              {/*        sx={{*/}
              {/*          backgroundColor: totalGapBackgroundColor,*/}
              {/*          borderRadius: "12px",*/}
              {/*          width: "24px",*/}
              {/*          height: "24px",*/}
              {/*          display: "flex",*/}
              {/*          justifyContent: "center",*/}
              {/*          alignItems: "center",*/}
              {/*        }}*/}
              {/*      >*/}
              {/*        <Typography*/}
              {/*          sx={{*/}
              {/*            fontSize: "12px",*/}
              {/*            fontFamily: "Roboto",*/}
              {/*            color: "rgba(0,0,0,0.87)",*/}
              {/*          }}*/}
              {/*        >*/}
              {/*          {totalGapValue}*/}
              {/*        </Typography>*/}
              {/*      </Box>} />*/}
              {/*    </Tabs>*/}
              {/*    <Divider sx={{*/}
              {/*      width: "100%",*/}
              {/*    }} />*/}
              {/*  </Box>*/}
              {/*)}*/}
              {!isGeneratingSchedule && activeTab === 0 && (
                <Box sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "100%",
                  gap: "8px",
                  paddingLeft: "45px",
                  paddingRight: "45px",
                }}>
                  <Typography sx={{
                    fontFamily: "Roboto",
                    fontSize: "14px",
                    fontWeight: 400,
                    lineHeight: "20px",
                    color: "rgba(0,0,0,0.87)",
                    marginLeft: "2px",
                  }}>
                    {t("full-time-shifts_review-movements-instruction")}
                  </Typography>
                  {/*<Button*/}
                  {/*  variant="outlined"*/}
                  {/*  sx={{*/}
                  {/*    fontFamily: "Roboto",*/}
                  {/*    fontSize: "14px",*/}
                  {/*    fontWeight: 500,*/}
                  {/*    lineHeight: "20px",*/}
                  {/*    whiteSpace: "nowrap",*/}
                  {/*    minWidth: "fit-content", // Allow width to grow with content*/}
                  {/*    maxWidth: "100%",*/}
                  {/*  }}*/}
                  {/*  onClick={() => {*/}
                  {/*    // Call API to generate the full-time shift schedule*/}
                  {/*  }}*/}
                  {/*  startIcon={<AutorenewOutlined />}*/}
                  {/*>*/}
                  {/*  Regenerate Schedule*/}
                  {/*</Button>*/}
                </Box>
              )}
            </Box>
          </DialogTitle>
          <DialogContent
            sx={{
              padding: "0px",
              overflow: "auto",
              flex: 1,
              height: "100%",
              width: "100%",
            }}
          >
            {isGeneratingSchedule && (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100%",
                  width: "100%",
                }}
              >
                <GenerateScheduleLoader open={true} isLoading={true} onClose={() => {
                  // Do nothing
                }} estimatedTimeInMs={20000} />
              </Box>
            )}
            {!isGeneratingSchedule && (
              <Box sx={{
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "center",
                height: "100%",
                width: "100%",
              }}>
                {activeTab === 0 && (<TotalWorkerMovement
                  startingDay={startDate}
                  workerReassignments={workerReassignments}
                />)}
              </Box>
            )}
          </DialogContent>
          {!isGeneratingSchedule && (<Divider />)}
          {!isGeneratingSchedule && (
            <DialogActions>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "100%",
                  paddingTop: "8px",
                  paddingBottom: "8px",
                  padding: "24px 25px 24px 25px"
                }}
              >
                <Box />
                <Box sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "flex-end",
                  gap: "8px"
                }}>
                  <Button
                    onClick={() => {
                      dispatch(closeGenerateFullTimeShiftSchedulerModal());
                    }}
                    variant="text"
                    sx={{
                      fontFamily: "Roboto",
                      fontSize: "14px"
                    }}
                  >
                    {t("common_cancel")}
                  </Button>
                  <LoadingButton
                    loadingPosition="start"
                    onClick={() => {
                      confirm({
                        confirmationButtonProps: {
                          variant: "contained",
                          color: "primary",
                        },
                        dialogProps: {
                          slotProps: {
                            paper: {
                              sx: {
                                p: "21px 21px 17px 21px",
                              },
                            }
                          }
                        },
                        title: <Typography
                          component="div"
                          sx={{
                          fontFamily: "Roboto",
                          fontSize: "20px",
                          fontWeight: 500,
                          lineHeight: "32px",
                          color: "rgba(0,0,0,0.87)",
                        }}>{t("full-time-shifts_confirm-schedule-changes")}</Typography>,
                        description: <Typography sx={{
                          fontFamily: "Roboto",
                          fontSize: "14px",
                          fontWeight: 400,
                          lineHeight: "20px",
                          color: "rgba(0,0,0,0.87)",
                          marginTop: "16px",
                        }}>
                          {t("full-time-shifts_publish-schedule-warning-1")}
                          <br />
                          {t("full-time-shifts_publish-schedule-warning-2")}
                        </Typography>,
                        confirmationText: t("full-time-shifts_confirm"),
                      }).then(() => {
                        let arrayOfSelectedReassignmentsId = workerReassignments?.filter(
                          (reassignment) => reassignment.isSelected
                        )?.map((reassignment) => reassignment.id);
                        // Unique the array of IDs
                        arrayOfSelectedReassignmentsId = Array.from(new Set(arrayOfSelectedReassignmentsId));
                        dispatch(saveOverrides({
                          reassignmentIds: arrayOfSelectedReassignmentsId,
                          locationId: locationId,
                          fromDate: format(dateRange?.startDate, "yyyy-MM-dd"),
                          toDate: format(addDays(dateRange?.startDate, 6), "yyyy-MM-dd"),
                        }));
                      }).catch(() => {
                        // Do nothing on cancel
                      });
                    }}
                    disabled={saveOverridesStatus === "pending"
                      || workerReassignments?.length === 0
                      || workerReassignments?.every((reassignment) => !reassignment.isSelected)
                  }
                    variant="contained"
                    sx={{
                      fontFamily: "Roboto",
                      fontSize: "14px",
                      color: "#fff"
                    }}
                    loading={saveOverridesStatus === "pending"}
                  >
                    {saveOverridesStatus === "pending" ? t("full-time-shifts_saving-schedule") : t("full-time-shifts_save-schedule")}
                  </LoadingButton>
                </Box>
              </Box>
            </DialogActions>
          )}

          {generateScheduleStatus === "error" && (
            <Snackbar
              open={generateScheduleStatus === "error"}
              autoHideDuration={600}
              onClose={() => {
                try {
                  dispatch(resetGenerateSchedule());
                  dispatch(closeGenerateFullTimeShiftSchedulerModal());
                } catch (e) {
                  // Do nothing
                }
              }}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
            >
              <MuiAlert elevation={6} variant="filled" severity="error">
                {generateScheduleErrorMessage ?? t("full-time-shifts_error-generating-schedule")}
              </MuiAlert>
            </Snackbar>
          )}
          {saveOverridesStatus === "error" && (
            <Snackbar
              open={saveOverridesStatus === "error"}
              autoHideDuration={600}
              onClose={() => {
                try {
                  dispatch(resetSaveOverrides());
                  dispatch(resetGenerateSchedule());
                  dispatch(closeGenerateFullTimeShiftSchedulerModal());
                } catch (e) {
                  // Do nothing
                }
              }}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
            >
              <MuiAlert elevation={6} variant="filled" severity="error">
                {saveOverridesErrorMessage ?? t("full-time-shifts_error-saving-schedule")}
              </MuiAlert>
            </Snackbar>
          )}
          {saveOverridesStatus === "fulfilled" && (
            <Snackbar
              open={saveOverridesStatus === "fulfilled"}
              autoHideDuration={600}
              onClose={() => {
                try {
                  dispatch(resetSaveOverrides());
                  dispatch(resetGenerateSchedule());
                  dispatch(closeGenerateFullTimeShiftSchedulerModal());
                } catch (e) {
                  // Do nothing
                }
              }}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
            >
              <MuiAlert elevation={6} variant="filled" severity="success">
                {t("full-time-shifts_schedule-saved-success")}
              </MuiAlert>
            </Snackbar>
          )}
        </Box>
      </Dialog>
  );
};